import { render, staticRenderFns } from "./MInplayList.vue?vue&type=template&id=a2122cde&scoped=true"
import script from "./MInplayList.vue?vue&type=script&lang=js"
export * from "./MInplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2122cde",
  null
  
)

export default component.exports